import app from 'flarum/forum/app';
import extendNotificationGridWithTeams from './extendNotificationGridWithTeams';

app.initializers.add('sbp-jm/flarum-msteams-webhook', () => {
  extendNotificationGridWithTeams();
});
